import type { TFunction } from 'i18next';

export const formatRelativeActivity = (value: string, t: TFunction): string => {
  const date = new Date(value);
  const days = Math.floor((Date.now() - date.getTime()) / 86_400_000);

  if (Number.isNaN(date.getTime())) {
    return '—';
  }

  if (days <= 0) {
    return t('pages.admin.users.activity.today');
  }

  if (days === 1) {
    return t('pages.admin.users.activity.yesterday');
  }

  if (days < 30) {
    return t('pages.admin.users.activity.daysAgo', { count: days });
  }

  return date.toLocaleDateString();
};
